import './CardSlide.css'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

function CardSlide () {
    const navigate = useNavigate();

    let guitars = useSelector(state => state.guitars);
    let [cardIndex, setCardIndex] = useState(0);
    let [cardsPerPage, setCardsPerPage] = useState(7);
    const maxIndex = Math.ceil(guitars.length / cardsPerPage) - 1;

    const handlePrevSlide = () => {
        setCardIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleNextSlide = () => {
        setCardIndex((prev) => Math.min(prev + 1, maxIndex));
    };

    const goToPage = (page) => {
        setCardIndex(page);
    };

    const calculateCardsPerPage = () => {
        if (window.innerWidth <= 650) return 2;
        if (window.innerWidth <= 1000) return 4;
        return 6;
    };

    useEffect(() => {
            const handleResize = () => {
                setCardsPerPage(calculateCardsPerPage());
            };
    
            handleResize();
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

    return (
        <>
        {/* 카드 섹션 */}
            <section className="card-section common-padding">
                <h2>
                    Most viewed
                    <div className="arrow-icon"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL + `/arrow_right_black.png`})` }}
                        onClick={() => { navigate('/shop') }}></div>
                </h2>

                <div className='card-container'>
                    <button className={`arrow prev-arrow ${cardIndex === 0 ? 'isEnd' : ''} `} onClick={handlePrevSlide}>←</button>
                    <button className={`arrow next-arrow ${cardIndex === maxIndex ? 'isEnd' : ''} `} onClick={handleNextSlide}>→</button>
                    <div className="card-wrapper" style={{
                        transform: `translateX(-${cardIndex * 100}%)`
                    }}>
                        {guitars.map((guitar, index) => (
                            <div className="card" key={guitar.id} onClick={() => { navigate(`/shop/${guitar.id}`) }}>
                                <div className='card-image-box'>
                                    <img src={`${process.env.PUBLIC_URL}/guitar/guitar-${guitar.id}-${guitar.title}.jpg`} alt={guitar.title} className="card-image" />
                                </div>
                                <div className="card-content">
                                    <h3>{guitar.title}</h3>
                                    <p>{guitar.price.toLocaleString()}</p>
                                    <small>{guitar.updated}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 페이지네이션 */}
                <div className="pagination">
                    {Array.from({ length: Math.ceil(guitars.length / cardsPerPage) }, (_, pageIndex) => (
                        <button
                            key={pageIndex}
                            className={`pagination-dot ${pageIndex === cardIndex ? 'active' : ''}`}
                            onClick={() => goToPage(pageIndex)}
                        />
                    ))}
                </div>
            </section>
        </>
    )
}

export default CardSlide